export class DayEquipPara {
    constructor({
          id= null,           
          day= ``,
          locName= ``,            
          equipRate= ``,
          calendarTime= ``,
          workTime= ``,
          downTime= ``,
          repairTime= ``,
          waitMaterial= ``,
          waitElectric= ``,
          waitGas= ``,
          littleRepair= ``,
          equip= ``,
          electric= ``,
          operate= ``,
          other= ``,
      } = {}) {
      this.id = id;     
      this.day = day;
      this.locName = locName;     
      this.equipRate = equipRate;
      this.calendarTime = calendarTime;
      this.workTime = workTime;
      this.downTime = downTime;
      this.repairTime = repairTime;
      this.waitMaterial = waitMaterial;
      this.waitElectric = waitElectric;
      this.waitGas = waitGas;
      this.littleRepair = littleRepair;
      this.equip = equip;
      this.electric = electric;
      this.operate = operate;
      this.other = other;
    }
  }
  export function gridFields() {
    return Object.freeze([          
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }          
        }, 
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },        
        {
          key: 'equipRate',
          label: 'lbl.prd.execution.equipRate',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'calendarTime',
          label: 'lbl.prd.execution.calendarTime',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'workTime',
          label: 'lbl.prd.execution.workTime',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'downTime',
          label: 'lbl.prd.execution.downTime',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'repairTime',
          label: 'lbl.prd.execution.repairTime',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'waitMaterial',
          label: 'lbl.prd.execution.waitMaterial',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'waitElectric',
          label: 'lbl.prd.execution.waitElectric',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'waitGas',
          label: 'lbl.prd.execution.waitGas',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'littleRepair',
          label: 'lbl.prd.execution.littleRepair',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'equip',
          label: 'lbl.prd.execution.equip',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'electric',
          label: 'lbl.prd.execution.electric',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'operate',
          label: 'lbl.prd.execution.operate',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'other',
          label: 'lbl.prd.execution.other',
          sortable: false,
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new DayEquipPara()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.plantFilter',
    'filter.startDayFilter',
    'filter.endDayFilter', 
  ];
  export const filter = {
    'plantFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
  };